import React, { Component } from "react";
import "./carousel.css";

class Carousel extends Component {
  state = {
    images: [
      {
        url:
          "http://res.cloudinary.com/dydyt6wbt/image/upload/c_scale,w_1800/v1536369818/batuhan/IMG_0661.jpg"
      },
      {
        url:
          "http://res.cloudinary.com/dydyt6wbt/image/upload/c_scale,w_1800/v1536369826/batuhan/IMG_0653.jpg"
      },
      {
        url:
          "http://res.cloudinary.com/dydyt6wbt/image/upload/c_scale,w_1800/v1536369828/batuhan/IMG_0649.jpg"
      }
    ],
    activeIndex: 0
  };
  rightHandle = () => {
    if (this.state.activeIndex === this.state.images.length - 1) {
      this.setState({ activeIndex: 0 });
    } else {
      this.setState(prev => ({ activeIndex: prev.activeIndex + 1 }));
    }
  };
  leftHandle = () => {
    if (this.state.activeIndex === 0) {
      this.setState(prev => ({ activeIndex: prev.images.length - 1 }));
    } else {
      this.setState(prev => ({ activeIndex: prev.activeIndex - 1 }));
    }
  };
  render() {
    const { images, activeIndex } = this.state;
    return (
      <div className="carousel carousel-animated carousel-animate-slide">
        <div className="carousel-container">
          {images &&
            images.map((image, index) => {
              let order;
              if (activeIndex === index) order = 1;
              if (activeIndex > index) order = 1 + (activeIndex - index);
              if (activeIndex < index) order = activeIndex - index - 1;
              const style = {
                order: order.toString(),
                zIndex: order.toString()
              };
              return (
                <div
                  key={index}
                  className={`carousel-item has-background ${
                    activeIndex === index ? "active" : ""
                  }`}
                  // style={style}
                >
                  <img
                    className="is-background carousel-img"
                    src={image.url}
                    alt=""
                    // width="640"
                    // height="310"
                  />
                  {/* <div className="title">Merry Christmas</div> */}
                </div>
              );
            })}
        </div>
        <div className="carousel-navigation is-overlay">
          <div className="carousel-nav-left" onClick={this.leftHandle}>
            <i className="fa fa-chevron-left" aria-hidden="true" />
          </div>
          <div className="carousel-nav-right" onClick={this.rightHandle}>
            <i className="fa fa-chevron-right" aria-hidden="true" />
          </div>
        </div>
      </div>
    );
  }
}

export default Carousel;



// WEBPACK FOOTER //
// ./src/components/carousel/Carousel.js